import { z } from 'zod';

/**
 * Request-body validation lives here, and the inferred types are what the API client's method
 * signatures use — so a schema change is a compile error at every call site.
 */

export const loginSchema = z.object({
  username: z.string().min(1).max(64),
  password: z.string().min(1).max(128),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const pageParamsSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
export type PageParamsInput = z.infer<typeof pageParamsSchema>;
